export default __webpack_public_path__ + "static/media/promo-a-new.a62bc58c.png";